import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const FinancialAccountsTransactionsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "FinancialAccountsTransactions" */
      '../../../components/MoneyManagement/FinancialAccountsTransactions'
    ),
  releaseState: 'internal',
  enabledOverrideFlag: ComponentOverrideFlag.financial_accounts_transactions,
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays a list of transactions for all financial accounts.',
  friendlyName: 'Financial accounts transactions',
  enableV2APIToken: true,
};
